import { IFetchContractCancellationCommunicationsDTO } from 'modules/customer/domain/dtos';
import { IContractCancellationsRepository } from 'modules/customer/domain/repositories';

export class FetchContractCancellationCommunicationsUseCase {
  constructor(
    private contractCancellationsRepository: IContractCancellationsRepository,
  ) {}

  public async execute({
    cancellationId,
  }: IFetchContractCancellationCommunicationsDTO) {
    return this.contractCancellationsRepository.findCommunications({
      cancellationId,
    });
  }
}
